import React, { useState } from 'react'
import { SuspenseWithPerf, useFirebaseApp, useFirestoreDoc } from 'reactfire'
import { Box, CheckBox, Grid, Heading } from 'grommet'

import { propertyDescriptions } from '../../utils/emptyProperty'
import ShowPreference from './ShowPreference'

export default function Preference(props) {
  const { item, group, title } = props

  const firebaseApp = useFirebaseApp()
  const preferencesRef = firebaseApp
    .firestore()
    .collection(props.userID)
    .doc('preferences')
  const preferencesDoc = useFirestoreDoc(preferencesRef)
  const preferencesObject = preferencesDoc.data()

  const [checked, setChecked] = useState(
    preferencesObject[group][item] === 'disabled' ? false : true
  )

  const updatePreference = (value) => {
    preferencesRef.update({
      [group]: {
        ...preferencesObject[group],
        [item]: value
      }
    })
  }

  const onChange = (e) => {
    const check = e.target.checked
    setChecked(check)
    !check && updatePreference('disabled')
  }

  const [showDescription, setShowDescription] = useState(false)

  return (
    <SuspenseWithPerf fallback={null} traceId={`load-preference-${item}`}>
      <Box pad={{ vertical: 'medium', horizontal: 'large' }} gap="small">
        <Grid columns={['80%', '20%']} gap="small">
          <Heading
            level={4}
            style={{ textAlign: 'left' }}
            onClick={() => {
              setShowDescription(!showDescription)
            }}
          >
            <span
              style={{
                color: showDescription ? 'white' : '#00739D',
                border: '1px solid #00739D',
                backgroundColor: showDescription ? '#00739D' : 'transparent',
                padding: '0 7px',
                borderRadius: '50%',
                lineHeight: '0',
                fontSize: '14px'
              }}
            >
              i
            </span>
            &nbsp;
            {title}
          </Heading>
          <Box
            style={{
              justifySelf: 'center'
            }}
          >
            <CheckBox id={item} checked={checked} toggle onChange={(e) => onChange(e)} />
          </Box>
        </Grid>
        <p>{showDescription && propertyDescriptions[item]}</p>
        <ShowPreference
          enabled={checked}
          preference={item}
          group={group}
          userID={props.userID}
        />
      </Box>
    </SuspenseWithPerf>
  )
}
